import React, { memo, FC } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import useQtyUpdateSelector from "./useQtyUpdateSelector";

const StyledFormControl = styled(FormControl)({
  position: "absolute",
  zIndex: 10,
  right: 5,
  top: 55,
});

export type ChangeQtyFn = (unitId: string, value: string | number) => void;

interface QuantityUpdateProps {
  changeQuantity: ChangeQtyFn;
  unitId: string;
  unitQuantity: number | string;
  isEditDisabled: boolean
}

const QuantityUpdate: FC<QuantityUpdateProps> = ({
  changeQuantity,
  unitId,
  unitQuantity,
  isEditDisabled
}) => {
  const { handleChange, qtyOptions } = useQtyUpdateSelector(
    changeQuantity,
    unitId
  );

  return (
    <StyledFormControl variant="outlined" size="small">
      <Select
        onChange={handleChange}
        value={unitQuantity}
        autoWidth={true}
        inputProps={{
          sx: {
            paddingLeft: "5px",
          },
        }}
        sx={{ height: 20, fontSize: 12 }}
        disabled={isEditDisabled}
      >
        {qtyOptions.map((qty) => (
          <MenuItem dense={true} value={qty} key={qty}>
            Qty: {qty}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
};

export default memo(QuantityUpdate);
